const Notifications = () => import("Core/configuration/notifications/views/Notifications");
const NotificationsForm = () => import("Core/configuration/notifications/views/NotificationsForm");
const MeNotifications = () => import("System/modules/users/views/UserMyNotifications");
// const CreateNotification = () => import("Core/configuration/notifications/views/CreateNotification");

export default {
    children: [
        {
            path: "configuration/notifications",
            name: "notifications",
            component: Notifications,
            meta: {
                requiresAuth: true,
                title: "lang.notifications",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/notification/:id?",
            name: "notification",
            component: NotificationsForm,
            meta: {
                requiresAuth: true,
                title: "lang.notifications",
                restrict_by_login_type: ["employee", "customer_support", "administrator", "developer"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "me/notifications/:id?",
            name: "me-notifications",
            component: MeNotifications,
            meta: {
                requiresAuth: true,
                title: "lang.my_notifications",
                restrict_by_login_type: [
                    "employee",
                    "customer_support",
                    "administrator",
                    "developer",
                    "csr",
                    "producer",
                    "dispatcher",
                    "technician",
                    "driver",
                    "dispenser_mgr",
                    "d_acct_mgr",
                    "customer_readonly",
                    "customer",
                    "distributor",
                ],
                restrict_by_permission: [],
            },
        },
        // {
        //     path: "configuration/create_notification",
        //     name: "settings_create_notification",
        //     component: NotificationsForm,
        //     meta: {
        //         requiresAuth: true,
        //         title: "lang.create_notification",
        //         restrict_by_login_type: ["customer_support", "administrator", "developer"],
        //         restrict_by_permission: ["configuration.read"],
        //     },
        // },
    ],
};
